import React from "react"
import { Container, Row, Col, Card } from "reactstrap"
import { TextBlock, TitleH2 } from "../../components/textBlock/TextBlock"
import { Ovm } from "../../layout/ovm/Ovm"
import { Section } from "../../layout/section/Section"

const FactsOne = (props) =>{
    return(
        <Section className={props.className && props.className} id={props.id && props.id}>
            <Container>
                <Row className="g-gs align-items-center">
                    <Col lg="5">
                        <TextBlock className="is-dark pe-xl-5">
                            <TitleH2>Unlocking Unforgettable Experiences!</TitleH2>
                            <p className="lead" style={{color: "white"}}>BidToWin is setting new global standards in the world of Auctions.</p>
                        </TextBlock>
                    </Col>
                    <Col lg="7">
                        <Row className="justify-center text-center g-gs">
                            <Col sm="4" xs="6">
                                <Card className="card-full round-xl">
                                    <div className="card-inner card-inner-md">
                                        <div className="h1 fw-bold text-purple" style={{fontSize: 27}}>120 +</div>
                                        <div className="h6 text-base">Auctions held successfully at the time of update.</div>
                                    </div>
                                </Card>
                            </Col>
                            <Col sm="4" xs="6">
                                <Card className="card-full round-xl">
                                    <div className="card-inner card-inner-md">
                                        <div className="h1 fw-bold text-success" style={{fontSize: 27}}>1500 +</div>
                                        <div className="h6 text-base">Vehicles listed till date by various sellers & banks.</div>
                                    </div>
                                </Card>
                            </Col>
                            <Col sm="4" xs="6">
                                <Card className="card-full round-xl">
                                    <div className="card-inner card-inner-md">
                                        <div className="h1 fw-bold text-pink" style={{fontSize: 27}}>23000 +</div>
                                        <div className="h6 text-base">Total bids on listed vehicles by registered bidders.</div>
                                    </div>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
            <Ovm className="shape-b shape-cover" />
        </Section>
    )
}

export default FactsOne